const locale = {
	home:"Home",
	my_profile:"My profile",
	logout:"Logout",
	language: "Language",
	set_status:"Set Status",
	online:"Online",
	busy:"Away",
	absent:"Do not disturb",
	invisible:"Invisible",
	search_project: 'Search Project',
	closing_tab_will_logout: "You are about to close SCAI tab. This will log out your account.",
	select_project: 'Select Project',
	session_history: 'Session history',
	project_code: 'Code:',
	english:'English',
	japanese:'Japanese',
};

export default locale;
